module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    attrs: {
      "size": "lg",
      "id": "defaultModal",
      "hide-footer": "",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-header": "",
      "centered": ""
    }
  }, [(_vm.action.action === 'addDeliveryAddress') ? _c('AddDeliveryAddress', {
    attrs: {
      "action": _vm.action
    }
  }) : _vm._e(), _vm._v(" "), (_vm.action.action === 'editDeliveryAddress') ? _c('EditDeliveryAddress', {
    attrs: {
      "action": _vm.action
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-121ccb2b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/orders/modal/Modal.vue
// module id = 3023
// module chunks = 0